import React, { useState, useEffect } from "react";
import { useMemberstack, } from "@memberstack/react";
//img et icn
import { ArrowUpRightIcon } from '@heroicons/react/20/solid'
import { CheckIcon } from '@heroicons/react/20/solid'
import { CheckBadgeIcon, DocumentCheckIcon } from "@heroicons/react/24/solid";
import AddressInput from "../components/AdresseInput";
import { StarIcon } from '@heroicons/react/24/solid'
import FaqOnboard from "../components/FaqOnboard";



const timeline = [
    {
        id: 1,
        content: 'Informations sur votre situation',
        target: 'Etape validée',
        icon: CheckIcon,
        iconBackground: 'bg-slate-700',
    },
    {
        id: 2,
        content: 'Commande',
        target: 'Choisissez votre formule et finalisez votre commande',
        icon: ArrowUpRightIcon,
        iconBackground: 'bg-indigo-600',
    },
    {
        id: 4,
        content: 'Vos actes notariés',
        target: 'Votre notaire valide vos informations et rédige vos actes notariés.',
        icon: DocumentCheckIcon,
        iconBackground: 'bg-slate-300',
    }
]


const includedFeatures = [
    'Accompagnement juridique jusqu’à la signature',
    'Sécurité et confidentialité de vos données',
    'Rapide grâce au process 100% en ligne',
    'Suivi et conseils personnalisés',
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function FormNotaireImmo() {
    const memberstack = useMemberstack();
    const [member, setMember] = useState(null);
    const [marie, setMarie] = useState(null);
    const [objectif, setObjectif] = useState(null);
    const [prenom, setPrenom] = useState(null);
    const [nom, setNom] = useState(null);
    const [telephone, setTelephone] = useState(null);
    const [email, setEmail] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [adresse, setAdresse] = useState(null);
    const [cp, setCp] = useState(null);
    const [ville, setVille] = useState(null);
    const [bienImmo, setBienImmo] = useState(null);
    const [valeurImmo, setValeurImmo] = useState(null);
    //step
    const [step1, setStep1] = useState(true);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [stepEnd, setStepEnd] = useState(false);
    const [stepPaiement, setStepPaiement] = useState(false);
    const [sendData, setSendData] = useState(false);


    //set member if logged
    useEffect(() => {
        memberstack.getCurrentMember()
            .then(({ data: member }) => setMember(member))
    }, []);


    const handleSubmitCoordonnees = (event) => {
        event.preventDefault();
        setPrenom(event.target.prenom.value);
        setNom(event.target.nom.value);
        setEmail(event.target.email.value);
        setTelephone(event.target.telephone.value);
        setStep4(false);
        setStep5(true);
    }

    const handleSubmitAdresse = (event) => {
        event.preventDefault();
        setAdresse(selectedAddress);
        setStep5(false);
        setStepEnd(true);
    }


    useEffect(() => {
        if (sendData === true) {
            //on envoie la data a zapier
            const sendToZapier = async () => {
                const zapierURL = "https://hooks.zapier.com/hooks/catch/7206204/2fywvbc/"; // 👈 Specify your Zapier Webhook URL here
                try {
                    const response = await fetch(zapierURL, {
                        method: "POST",
                        mode: "cors",
                        body: JSON.stringify({ marie, objectif, prenom, nom, telephone, email, adresse, cp, ville, bienImmo, valeurImmo })
                    });
                    const res = await response.json();
                    console.log(res);
                } catch (e) {
                    console.log(e);
                }
            };
            sendToZapier();
        }
    }, [sendData]);

    return (
        <>
            <div
                className={`sm:mx-auto w-full  flex flex-col sm:items-center ${stepPaiement === true ? "" : "lg:max-w-xl"}`}
            >

                {/** q1 */}
                {step1 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">1</span>/6</p>
                            <h2 className="text-2xl/9 font-bold tracking-tight text-gray-900">Êtes-vous déjà mariés ?</h2>
                        </div>

                        <div className="sm:mt-10 w-full">
                            <ul className="grid gap-1 md:grid-cols-1 p-0">
                                <li>
                                    <input type="radio" id="oui" name="start" className="hidden peer" required onClick={() => { setMarie("oui"); setStep1(false); setStep2(true); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Oui
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="non" name="start" className="hidden peer" required onClick={() => { setMarie("non"); setStep1(false); setStep2(true); }} />
                                    <label htmlFor="non" className="radio-button">
                                        Non, pas encore
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </>
                }
                {/** objectif */}
                {step2 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">2</span>/6</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Quelle est votre objectif principal ?</h2>
                        </div>

                        <div className="sm:mt-10 w-full">
                            <ul className="grid gap-1 md:grid-cols-1 p-0">
                                <li>
                                    <input type="radio" id="bien" name="objectif" className="hidden peer" required onClick={() => { setObjectif("bien"); setStep2(false); setStep3(true); }} />
                                    <label htmlFor="bien" className="radio-button">
                                        Protéger mes biens personnels
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="transmission" name="objectif" className="hidden peer" required onClick={() => { setObjectif("transmission"); setStep2(false); setStep3(true); }} />
                                    <label htmlFor="transmission" className="radio-button">
                                        Faciliter la transmission successorale
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="conflit" name="objectif" className="hidden peer" required onClick={() => { setObjectif("conflit"); setStep2(false); setStep3(true); }} />
                                    <label htmlFor="conflit" className="radio-button">
                                        Éviter les conflits en cas de divorce
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="nesaispas" name="objectif" className="hidden peer" required onClick={() => { setObjectif("nesaispas"); setStep2(false); setStep3(true); }} />
                                    <label htmlFor="nesaispas" className="radio-button">
                                        Je ne sais pas encore.
                                    </label>
                                </li>
                            </ul>

                        </div>
                    </>
                }

                {/** bien immo */}
                {step3 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">3</span>/6</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Avez-vous des biens immobiliers à protéger</h2>
                        </div>

                        <div className="mt-10 w-full">

                            <ul className="grid w-full gap-1 md:grid-cols-1 p-0">
                                <li className="w-full">
                                    <input type="radio" id="oui" name="immo" className="hidden peer" required onClick={() => { setBienImmo("oui"); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Oui
                                    </label>
                                </li>
                                <li className="w-full">
                                    <input type="radio" id="non" name="immo" className="hidden peer" required onClick={() => { setBienImmo("non"); setStep3(false); setStep4(true); }} />
                                    <label htmlFor="non" className="radio-button">
                                        Non
                                    </label>
                                </li>
                            </ul>

                            {bienImmo === "oui" && <>
                                <h2 className="mt-10 text-2xl/9 font-bold tracking-tight text-gray-900">Quelle est la valeur de ce(s) bien(s) ?</h2>
                                <ul className="flex flex-col gap-2">
                                    <li>
                                        <input type="radio" id="moins30" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("moins30"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="moins30" className="radio-button">
                                            Moins de 30 800€
                                        </label>
                                    </li>
                                    <li>
                                        <input type="radio" id="30200" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("30200"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="30200" className="radio-button">
                                            Entre 30 800 et 200 000€
                                        </label>
                                    </li>
                                    <li>
                                        <input type="radio" id="200500" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("200-500"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="200500" className="radio-button">
                                            Entre 200 000 et 500 000€
                                        </label>
                                    </li>
                                    <li>
                                        <input type="radio" id="plus500" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("plus500"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="plus500" className="radio-button">
                                            Plus de 500 000€
                                        </label>
                                    </li>
                                </ul>
                            </>}
                        </div>
                    </>
                }

                {/** coordonnées */}
                {step4 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">4</span>/6</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Quelles sont vos coordonnées</h2>
                            <p className="text-sm text-slate-600">Pas d'inquiétude on ne les vendra pas ! C'est uniquement pour vous joindre facilement en cas de besoin.</p>
                        </div>
                        <form action="#" method="POST" className="w-full space-y-6" data-ms-form="signup" onSubmit={handleSubmitCoordonnees}>
                            <div className="grid sm:grid-cols-2 gap-3 w-full">
                                <div>
                                    <label className="block text-base font-medium text-gray-900"> Votre Nom<sup>*</sup></label>
                                    <input
                                        required
                                        name="nom"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                                <div>
                                    <label className="block text-base font-medium text-gray-900">Votre Prénom<sup>*</sup> </label>
                                    <input
                                        required
                                        name="prenom"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-base font-medium text-gray-900">
                                    Votre Email<sup>*</sup>
                                </label>
                                <div className="mt-2">
                                    <input
                                        required
                                        name="email"
                                        type="email"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-base font-medium text-gray-900">
                                    Votre Téléphone<sup>*</sup>
                                </label>
                                <div className="mt-2">
                                    <input
                                        required
                                        name="telephone"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="btn-indigo no-underline p-4"
                                >
                                    Continuer
                                </button>
                            </div>
                        </form>


                    </>
                }

                {/** adresse */}
                {step5 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">5</span>/6</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Quelle est votre adresse ?</h2>
                        </div>

                        <div className="mt-10 w-full">
                            <form action="#" method="POST" className="space-y-6 w-full" onSubmit={handleSubmitAdresse}>
                                <div>
                                    <label className="block text-base font-medium text-gray-900">
                                        Adresse<sup>*</sup>
                                    </label>
                                    <AddressInput className="input-clotere" onAddressSelect={(place) => setSelectedAddress(place)} />
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="btn-indigo  no-underline  p-4"
                                    >
                                        Continuer
                                    </button>
                                </div>
                            </form>
                        </div>
                    </>
                }



                {/** etape intermédiaire */}
                {stepEnd === true &&
                    <>
                        <div className="">
                            <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                                <CheckIcon aria-hidden="true" className="size-6 text-green-600" />
                            </div>
                            <div className="mt-3 text-center sm:mt-5">
                                <h2 as="h3" className=" text-2xl/9 font-bold tracking-tight text-gray-900">
                                    Nous avons les informations nécessaires. Voici les prochaines étapes :
                                </h2>
                                <div className="flow-root relative mb-3">
                                    <ul role="list" className=" mt-10">
                                        {timeline.map((event, eventIdx) => (
                                            <li key={event.id}>
                                                <div className="relative pb-3">
                                                    {eventIdx !== timeline.length - 1 ? (
                                                        <span aria-hidden="true" className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" />
                                                    ) : null}
                                                    <div className="relative flex space-x-3 items-center">
                                                        <div>
                                                            <span
                                                                className={classNames(
                                                                    event.iconBackground,
                                                                    'flex size-8 items-center justify-center rounded-full ring-8 ring-white',
                                                                )}
                                                            >
                                                                <event.icon aria-hidden="true" className="size-5 text-white" />
                                                            </span>
                                                        </div>
                                                        <div className="flex min-w-0 flex-1 justify-start space-x-4 pt-1.5 text-left">
                                                            <div>
                                                                <p className="text-lg text-gray-500 m-0">
                                                                    {event.content}<br />{' '}
                                                                    <span className="font-medium text-black">{event.target}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>

                                </div>
                                <a
                                    href="#"
                                    onClick={() => { setStepEnd(false); setStepPaiement(true); setSendData(true) }}
                                    className="btn-indigo  no-underline  p-4"
                                >
                                    Continuer
                                </a>
                            </div>

                        </div>
                    </>
                }

                {/** etape paiement */}
                {stepPaiement === true &&
                    <>
                        <div className="mx-auto  px-6 lg:px-8">
                            <h2 className="font-bold text-center">Votre contrat de mariage simplifié et sécurisé</h2>
                            <p className="text-base/7 text-gray-600 text-center">
                                Clotere.fr simplifie la création de votre dossier notarial et vous connecte à un notaire réactif pour un traitement rapide.
                            </p>

                            <div className="mx-auto  rounded-3xl ring-1 ring-gray-200 lg:mx-0 lg:flex lg:max-w-none">
                                <div className="p-8 sm:p-10 lg:flex-auto">
                                    <div className="flex-row">

                                        <div className="flex items-center gap-x-4">
                                            <h4 className="flex-none text-sm/6 font-semibold ">Ce qui est inclus</h4>
                                            <div className="h-px flex-auto bg-gray-100" />
                                        </div>
                                    </div>

                                    <ul role="list" className="pl-0 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-6">
                                        {includedFeatures.map((feature) => (
                                            <li key={feature} className="flex gap-x-3 font-bold">
                                                <CheckBadgeIcon aria-hidden="true" className="h-6 w-5 flex-none text-indigo-600" />
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                    <figure className="mx-auto max-w-2xl bg-slate-50 rounded-md p-4 mt-10">
                                        <div className="flex gap-x-1 text-indigo-600">
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                        </div>
                                        <blockquote className="text-xl font-semibold tracking-tight text-gray-900 mb-0">
                                            <p className="mb-0">
                                                “L'équipe est vraiment top, le service client que j'ai reçu de leur part a parfaitement répondu à mes attentes. Merci”
                                            </p>
                                        </blockquote>
                                        <figcaption className="flex items-center gap-x-6">

                                            <div className="text-sm/6">
                                                <div className="font-regular text-gray-900">Aurore, <span className="font-regular text-gray-600">A réalisé son contrat de mariage sur Clotere</span></div>

                                            </div>
                                        </figcaption>
                                    </figure>
                                </div>

                                <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                    <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
                                        <div className="mx-auto max-w-xs px-8">
                                            
                                            <p className="mt-6 flex items-baseline justify-center gap-x-2">
                                                <span className="text-5xl font-semibold tracking-tight text-gray-900">369€</span>

                                            </p>
                                            <a
                                                href={"https://buy.stripe.com/cN2cOK2RLe7zbTycMO?prefilled_email=" + email}
                                                className="no-underline mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            >
                                                Valider mon offire
                                            </a>
                                            <p className="mt-6 text-xs/5 text-gray-600">
                                                Paiement 100% sécurisé via notre partenaire Stripe
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <FaqOnboard type="mariage" />
                        </div>
                    </>
                }
            </div>
        </>
    );
}


export default FormNotaireImmo;